import { render, staticRenderFns } from "./ProgramReview.vue?vue&type=template&id=4c8c7b4a"
import script from "./ProgramReview.vue?vue&type=script&lang=js"
export * from "./ProgramReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports